export default "__VITE_ASSET__nFxsvji9__"